module.exports = __webpack_public_path__ + "img/wood.07bff301.png";